import { TmrBaseResource } from 'stylewhere/api'

export class Encoding extends TmrBaseResource {
  static endpoint = 'api/v1/encoding'
}
